import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CheckVerified02 = function CheckVerified02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m9 12 2 2 4.5-4.5m2.4012-4.5015c.2059.498.6012.8939 1.0989 1.1006l1.7451.7229a2.0326 2.0326 0 0 1 1.1001 2.6558l-.7224 1.744a2.03 2.03 0 0 0 .0007 1.5565l.7211 1.7435a2.033 2.033 0 0 1-1.1004 2.6567l-1.7439.7224a2.033 2.033 0 0 0-1.1006 1.0989l-.7229 1.7452a2.0323 2.0323 0 0 1-2.6557 1.1001l-1.7439-.7224a2.032 2.032 0 0 0-1.5552.0012l-1.7452.7219a2.033 2.033 0 0 1-2.654-1.0994l-.7232-1.7458A2.033 2.033 0 0 0 5.0008 17.9l-1.7451-.7229a2.033 2.033 0 0 1-1.1006-2.6546l.7224-1.7439a2.033 2.033 0 0 0-.0012-1.5553L2.155 9.4768A2.0326 2.0326 0 0 1 3.2554 6.82l1.7439-.7224A2.033 2.033 0 0 0 6.0993 5l.7229-1.7453a2.0326 2.0326 0 0 1 2.6557-1.1l1.7439.7223a2.033 2.033 0 0 0 1.5553-.0011l1.7459-.7201a2.0325 2.0325 0 0 1 2.6553 1.0999l.7231 1.7457z"
    })
  }));
};
export default CheckVerified02;